import { useQuery } from '@tanstack/react-query'
import { getCentrosTrabajo } from '../api/centros'

/**
 * Hook para obtener la lista de centros de trabajo
 *
 * La API devuelve:
 * {
 *   "code": 200,
 *   "payload": {
 *     "centrosTrabajo": [
 *       {
 *         "IdCentroTrabajo": 6,
 *         "Nombre": "Central Eurosol",
 *         "Lat": "36.791823",
 *         "Long": "-2.655672"
 *       }
 *     ]
 *   },
 *   "message": "..."
 * }
 */
export const useCentrosTrabajo = () => {
  return useQuery({
    queryKey: ['centrosTrabajo'],
    queryFn: getCentrosTrabajo,
    staleTime: 10 * 60 * 1000, // 10 minutos (los centros no cambian frecuentemente)
  })
}
